import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import React from "react";
import { type RuleSet } from "styled-components";
import { Select } from "~/features/ui/form/select";
import { FilterDropdown } from "~/features/filter/filter-dropdown";
import { RadioGroup } from "~/features/ui/form/radio-group";
import { hasItems } from "~/features/app/utils";
type Option = {
  label: string;
  value: string;
};
export type Filter = {
  title: string;
  options: Option[];
  type: "radio" | "dropdown" | "select";
  value?: string;
  style?: TwStyle | RuleSet<object>;
  tooltip?: React.ReactNode;
};
type Props = {
  filters: Filter[];
  onChange: (type: string, val: string) => void;
};
export function FilterBar(props: Props) {
  const {
    filters,
    onChange,
    ...rest
  } = props;
  if (!hasItems(filters)) {
    return null;
  }
  const renderFilter = (filter: Filter) => {
    if (filter.type === "radio") {
      return <_StyledDiv $_css={filter.style}>
          <RadioGroup key={filter.title} options={filter.options} onChange={val => onChange(filter.title, val)} value={filter.value} defaultValue="" />
        </_StyledDiv>;
    }
    if (filter.type === "dropdown") {
      return <_StyledDiv2 $_css2={filter.style}>
          <FilterDropdown key={filter.title} options={filter.options} onChange={val => onChange(filter.title, val)} value={filter.value} label={filter.title} name={filter.title} placeholder={`${filter.title}`} defaultValue="" />
        </_StyledDiv2>;
    }
    if (filter.type === "select") {
      return <_StyledDiv3 $_css3={filter.style}>
          <Select label={filter.title} options={filter.options} onChange={e => onChange(filter.title, e.target.value)} tooltip={filter.tooltip} value={filter.value} />
        </_StyledDiv3>;
    }
  };
  return <_StyledDiv4 {...rest}>
      {filters.map((filter, idx) => <React.Fragment key={idx}>{renderFilter(filter)}</React.Fragment>)}
    </_StyledDiv4>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-xklaui-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-xklaui-1"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-xklaui-2"
})`${p => p.$_css3}`;
var _StyledDiv4 = /*#__PURE__*/_styled4("div").withConfig({
  displayName: "filter-bar___StyledDiv4",
  componentId: "sc-m5r1nc-0"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "1.6rem"
});